import { createSelector } from '@ngrx/store';

import { authFeature } from '../auth.feature';

const { selectImpersonation } = authFeature;

export const selectIsImpersonationLoading = createSelector(
  selectImpersonation,
  ({ status }) => status === 'connecting' || status === 'disconnecting',
);

export const selectHasImpersonatedBuyer = createSelector(
  selectImpersonation,
  ({ status }) => status === 'connected',
);

export const selectImpersonatedBuyer = createSelector(
  selectImpersonation,
  ({ status, impersonatedBuyer }) =>
    status === 'connected' ? impersonatedBuyer : null,
);
